import AnimationDelay from '../utils/AnimationDelay';
import swap from '../utils/swap';

const bubblesort = async (a, delayController) => {
  return new Promise(async (resolve) => {
    const l = a.length;
    let notSorted = true;
    let iteration = 0;
    while(notSorted) {
      notSorted = false;
      for (let i = 0; i < (l - iteration);  i += 1) {
        let j = i + 1;
        let left = a[i];
        let right = a[j];
        if (right < left) {
          swap(a, i, j);
          notSorted = true;
        }
        await delayController.delay();
      }
      iteration += 1;
    }
    resolve();
  })
};
export default class BubbleSortAlgorithm {
  constructor({delayController} = {}) {
    this.delayController = delayController || new AnimationDelay();
  }
  sort = async (a) => {
    await bubblesort(a, this.delayController)
  }
}



// WEBPACK FOOTER //
// ./src/algorithms/bubblesort.js